
// ! rename the function to align with the widget name
export const servicesTabs = () => {
    const el = document.querySelector('.curious-services-tabs');
    if (!el) return;

    // ------------------------------------------------------------
    const tabButtons = el.querySelectorAll('.services-tab-button');
    const tabPanes = el.querySelectorAll('.services-tab-pane');

    tabButtons.forEach(button => {
        button.addEventListener('click', () => {
            const tabId = button.getAttribute('data-tab-id');

            // Remove active class from all buttons and panes
            tabButtons.forEach(btn => btn.classList.remove('active'));
            tabPanes.forEach(pane => pane.classList.remove('active'));

            // Add active class to clicked button and corresponding pane
            button.classList.add('active');
            const activePane = el.querySelector(`#${tabId}`);
            if (activePane) {
                activePane.classList.add('active');
            }
        });
    });
    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

